export default __webpack_public_path__ + "static/media/mode-2.4dfdfdf4.svg";